import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent, inject } from 'vue';
import ValidateService from 'pk/service/ValidateService';
import FormMixins from './FormMixins';
import ImagesBox from './components/ImagesBox.vue';
import FormField from './components/FormField.vue';
import RouterFactory from 'pk/factory/RouterFactory';
export default defineComponent({
  mixins: [FormMixins],
  components: {
    ImagesBox,
    FormField
  },
  props: {
    uploadParmas: {
      type: Object
    }
  },
  data() {
    return {
      fields: {
        file: ValidateService.genRule({
          label: this.field.label,
          rules: [ValidateService.upload]
        })
      },
      maxlength: 9,
      innerUploadParams: {
        _model: '',
        marking: '',
        info_id: ''
      },
      RouterService: new RouterFactory()
    };
  },
  setup() {
    const FormRender = inject('FormRender');
    return {
      FormRender
    };
  },
  created() {
    this.innerUploadParams.marking = this.RouterService.query('marking');
    this.field.rules = [].concat(this.fields.file.rules).concat(this.field.rules || []);
    this.genMaxLength();
    if (this.FormRender().infoService) {
      this.innerUploadParams._model = this.FormRender().infoService.modelName;
      this.innerUploadParams.info_id = this.FormRender().form.id ? this.FormRender().form.id.toString() : '';
    }
    if (this.uploadParmas) {
      Object.assign(this.innerUploadParams, this.uploadParmas || {});
    }
  },
  methods: {
    handleUploadSuccess() {
      this.FormRender().formElement.resetValidation(this.field.label);
    },
    genMaxLength() {
      const rule = (this.field.rules || []).find(res => res.max || res.len);
      if (rule) {
        this.maxlength = rule.max || rule.len;
      }
    }
  }
});